var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c(_vm.type,{tag:"component",staticClass:"font-semibold prose tracking-wider prose-headings:mb-0 prose-headings:text-unset prose-headings:font-semibold prose-strong:text-brandRed prose-strong:font-semibold prose-headings:text-[unset] prose-headings:leading-none",class:[
    _vm.colorItalic,
    _vm.colorBold,
    _vm.size,
    _vm.sizeDesktop,
    _vm.color,
    _vm.desktopAlign,
    _vm.align,
  ],attrs:{"title-component":""},domProps:{"innerHTML":_vm._s(_vm.text.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }